import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import markdownToSafeHtml from '../common/markdownToSafeHtml';

class FieldTemplate extends PureComponent {
  handleClick = () => {
    const { formContext, schema, required } = this.props;
    const onClickElement = formContext && formContext.onClickElement;

    if (onClickElement) {
      onClickElement({
        ...schema,
        required
      });
    }
  };

  render() {
    const {
      id,
      classNames,
      label,
      help,
      required,
      description,
      rawErrors,
      children,
      schema,
      formContext
    } = this.props;

    const {
      selectedElementId
    } = formContext;

    const selectedClass = selectedElementId === schema.id
      ? 'selected'
      : '';

    const classes = `field-container ${selectedClass} ${classNames}`;

    const clickable = formContext && formContext.onClickElement;
    const fieldTemplate = (
      <div
        role={clickable ? 'button' : 'presentation'}
        tabIndex={clickable ? 0 : undefined}
        className={classes}
        onClick={clickable ? this.handleClick : undefined}
      >
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="control-label" htmlFor={id}>
          {label}
          {required ? ' *' : null}
        </label>
        {typeof schema.description === 'string' && schema.description
          ? (
            <div
              id={`${id}__description`}
              className="field-description"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: markdownToSafeHtml(schema.description) }}
            />
          )
          : description}
        {children}
        {rawErrors.length > 0 && (
          <div>
            <ul className="error-detail bs-callout bs-callout-info">
              {rawErrors.map((error) => {
                // Custom error message for attachment fields
                let customError = error;
                if (schema.format === 'data-url' && error.includes('required')) {
                  customError = 'Please select a file to upload';
                }
                else if (error.includes('required')) {
                  customError = 'This field is required';
                }
                return (
                  <li key={error} className="text-danger">{customError}</li>
                );
              })}
            </ul>
          </div>
        )}
        {help}
      </div>
    );
  
    const formTemplate = (
      <div>
        {children}
      </div>
    );

    return id === 'root'
      ? formTemplate
      : fieldTemplate;
  }
}

FieldTemplate.defaultProps = {
  help: null,
  description: null,
  required: false,
  rawErrors: [],
  formContext: {}
};

FieldTemplate.propTypes = {
  id: PropTypes.string.isRequired,
  classNames: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  help: PropTypes.shape({
    key: PropTypes.string
  }),
  required: PropTypes.bool,
  description: PropTypes.shape({
    key: PropTypes.string
  }),
  rawErrors: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  schema: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    format: PropTypes.string
  }).isRequired,
  formContext: PropTypes.shape({
    onClickElement: PropTypes.func.isRequired,
    selectedElementId: PropTypes.string
  })
};

export default FieldTemplate;
